// extracted by mini-css-extract-plugin
export default {"form":"SelectClinicForm_form__jtV6X","formButton":"SelectClinicForm_formButton__g5+aE"};